// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["css/admin","css/app"], () => (__webpack_require__("./resources/assets/js/app.js")))
__webpack_require__.O(undefined, ["css/admin","css/app"], () => (__webpack_require__("./resources/assets/sass/front/app.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["css/admin","css/app"], () => (__webpack_require__("./resources/assets/sass/admin/admin.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
